import { web3 } from 'fbonds-core'

export const FRAGSOL_MINT = new web3.PublicKey('FRAGSEthVFL7fdqM8hxfxkfCZzUvmg21cqPJVvC1qdbo')
export const WFRAGSOL_MINT = new web3.PublicKey('WFRGSWjaz8tbAxsJitmbfRuFV2mSNwy7BMWcCwaA28U')
export const FRAGMETRIC_LOOKUP_TABLE = new web3.PublicKey(
  'HjNXH2HMfso5YU6U7McfhsbfoecGR5QTBAxTCSbFoYqy',
)
export { createWfragSolLeverageTxnData } from './createWfragSolLeverageTxnData'
export { fetchFragSolConversionRate } from './requests'
